import { ColourSwatch } from '../../../types/enterpriseTypes'

interface Product {
  options: {
    key: string
    choices: {
      colour?: string
      key: string
      title: string
    }[]
  }[]
  variants: {
    choices: {
      key: string
      optionKey: string
    }[]
    inStock: boolean
    product?: {
      url?: string
    } | null
  }[]
}

export const getColourSwatches = <ProductType extends Product>(
  product: ProductType | undefined,
): ColourSwatch[] => {
  if (!product || !product.options) {
    return []
  }
  return (
    product.options
      .find((option) => option.key === 'Colour')
      ?.choices.reduce(
        (swatches: NonNullable<ColourSwatch[]>, colourChoice) => {
          const href = product.variants.find(
            (variant) =>
              variant.inStock &&
              variant.choices.find(
                (choice) =>
                  choice.optionKey === 'Colour' &&
                  choice.key === colourChoice.key,
              ),
          )?.product?.url
          if (href && colourChoice.colour) {
            const swatch = {
              ...colourChoice,
              href,
              colour: colourChoice.colour,
              __typename: 'ColourSwatch',
            }

            if (colourChoice.colour === 'Multi') {
              swatches.unshift(swatch)
            } else {
              swatches.push(swatch)
            }
          }
          return swatches
        },
        [],
      ) || []
  )
}
